/**
 * Instant replay banner (VISION §8): while the match scene shows a VHS replay (`ui.replay`) the broadcast HUD steps
 * aside and this lower-third takes its place: a red "INSTANT REPLAY" bug, the play's title and line, SLOW-MO when the
 * tape slows down, and the skip prompt for the human players.
 */
import { ui } from '@hf/client-core/ui-model/store';
import { useServices } from '../actions';
import { ButtonCap, promptDevice } from './common';

export function ReplayBanner() {
  const r = ui.replay.value;
  const setup = ui.matchSetup.value;
  const { input } = useServices();
  if (!r) return null;
  const human = setup?.slots.findIndex((s) => s.kind === 'human') ?? -1;
  const device = human === 0 || human === 1 ? promptDevice(setup, human, input.lastActiveDevice()) : null;
  const showing = r.stage === 'play' || r.stage === 'hold';
  return (
    <div
      class={`hf-replay tone-${r.clip.tone} stage-${r.stage} ${showing ? 'on' : ''}`}
      role="status"
      aria-live="polite"
    >
      <div class="hf-replay__bug t-broadcast">
        <i aria-hidden="true" />
        INSTANT REPLAY
      </div>
      <div class="hf-replay__body">
        <div class="hf-replay__title t-display">{r.clip.title}</div>
        {r.clip.sub ? <div class="hf-replay__sub t-broadcast">{r.clip.sub}</div> : null}
      </div>
      {r.slowmo ? <div class="hf-replay__slow t-broadcast">SLOW-MO</div> : null}
      {r.skippable && device ? (
        <div class="hf-replay__skip t-broadcast">
          <ButtonCap device={device} button="A" /> SKIP
        </div>
      ) : null}
    </div>
  );
}
